import { getStore } from 'cadenza/store/cadenza-store';
import i18n from 'cadenza/workbook/header/workbook-header.properties';
import { isWorkbookSaved } from 'cadenza/workbook/workbook-core-selectors.state';

export function getShareButtonTitle() {
  return isWorkbookSaved(getStore().getState()) ? i18n('share.button') : i18n('share.button.disabled');
}
